
import React, {useContext, useEffect, useState} from 'react';
import {ambienteContext} from '../../context/Ambiente';
import {useAuth} from '../../hooks/use-auth';
import ReactDOM from 'react-dom';
import * as zoid from 'zoid/dist/zoid.min.js';
import  './app-bar-navigation.css';

let zoidRegistred = false;
let AppNavigation;
let widget ;

const AppBarNavigation = () => {

  const ambiente = useContext(ambienteContext);
  const [cred, setCred ]= useState({username:''});
  
  const {signOut, getCredentials} = useAuth();

  useEffect(() => {
     const carregaCredenciais = async () => {
       const newCred = await getCredentials();
       setCred(newCred);
     }
     carregaCredenciais();

     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  
  

  if(!zoidRegistred){

    widget = zoid.create({
      tag: 'cs-app-choose',
      url: ambiente.appBarNavigation.url,
      dimensions: {
        width: '240px',
        height: '100%'
      }
    });

    zoidRegistred = true;

    AppNavigation = widget.driver('react', {
      React: React,
      ReactDOM: ReactDOM    
    });

  }



  const logout = () => {
    signOut();
  
  }
  
  const onChangeState = (evt) => {
    window.location = evt;            
  }

  const chat = () => {
    let mensagem = "Olá, estou no sistema de devolução e preciso de um atendimento.";
    mensagem = encodeURI(mensagem);
    window.open("https://web.whatsapp.com/send?phone=551941414864&text="+mensagem+"&app_absent=0")
  }

  console.log('sideapp');

  if(cred.username){
    return (
      <AppNavigation onLogout={logout} onSupport={chat} credenciais={cred} onChangeState={onChangeState}></AppNavigation>
    );
  } else {
    return (<></>);
  }

}




export {AppBarNavigation}